import { isSidebarVisible } from "../utils";
import {
  initializeAllDayCheckbox,
  initializeDateTimeFields,
} from "../datetime";
import { initializeChoices } from "../choices";
import { initializeFileUpload } from "../files";
import { addAlert } from "../alerts";
import { initializeNumberSpinner } from "../interface";
import { initializeCheckTrailer } from "./check-trailer";

function initializeToggles(form) {
  const togglesScript = form
    .closest(".multiform-wrapper")
    .querySelector("script");
  const prefix = togglesScript.id;
  const toggles = JSON.parse(togglesScript.textContent);
  toggles.forEach((toggle) => {
    const toggleInput = form.querySelector(`#id_${prefix}-${toggle[0]}`);
    const affectedInput = form.querySelector(`#id_${prefix}-${toggle[1]}`);

    toggleInput.addEventListener("change", function (e) {
      affectedInput.disabled = !toggleInput.checked;
    });
  });
}

export function initializeMultiformSaveBanner(element) {
  const sidebar = document.querySelector("#sidebar");
  const forms = document.querySelectorAll("form.multiform");
  const orderList = document.getElementById("orderList");
  let modifiedForms = [];
  let previousOrders = [];
  let modifiedOrders = [];

  if (orderList) {
    previousOrders = Array.from(orderList.children).map(
      (item) => item.dataset.itempk,
    );
    orderList.addEventListener("list-changed", function (e) {
      element.classList.remove("hidden");
      element.classList.add("shown");
      modifiedOrders = Array.from(orderList.children).map(
        (item) => item.dataset.itempk,
      );
    });
  }

  forms.forEach(function (form) {
    const isDisabled =
      form.closest(".multiform-wrapper").dataset.disabled === "True";
    if (isDisabled) return;
    form.addEventListener("keyup", function (e) {
      if (!modifiedForms.includes(form)) {
        element.classList.remove("hidden");
        element.classList.add("shown");
        modifiedForms.push(form);
      }
    });
    form.addEventListener("change", function (e) {
      if (!modifiedForms.includes(form)) {
        element.classList.remove("hidden");
        element.classList.add("shown");
        modifiedForms.push(form);
      }
    });

    initializeToggles(form);
  });

  sidebar.addEventListener("toggled", function (e) {
    if (e.detail) {
      element.classList.add("sidebar-margin");
    } else {
      element.classList.remove("sidebar-margin");
    }
  });

  if (isSidebarVisible()) element.classList.add("sidebar-margin");

  window.onscroll = function () {
    if (
      window.innerHeight + Math.round(window.scrollY) + 30 >=
      document.body.offsetHeight
    ) {
      element.classList.add("bottom");
    } else {
      element.classList.remove("bottom");
    }
  };

  element
    .querySelector(".btn-submit")
    .addEventListener("click", async function () {
      let hasError = false;
      let errorForm = null;

      for (const form of modifiedForms) {
        let badge = form.querySelector(".badge");
        if (badge) {
          badge.textContent = gettext("SAVING...");
          badge.classList = "badge saving";
        }

        const formData = new FormData(form);
        try {
          const response = await fetch(form.action, {
            method: "post",
            body: formData,
            headers: {
              ajax: true,
            },
          });
          const contentType = response.headers.get("content-type");
          let truckChanged = false;
          if (
            form.action.includes("driver") &&
            contentType &&
            contentType.includes("application/json")
          ) {
            const json = await response.json();
            truckChanged = json.truck_changed || false;
            const driverForm = document.querySelector(
              "form[data-form-prefix='driver']",
            );
            if (driverForm) {
              const driverResponse = await fetch(driverForm.action, {
                headers: { ajax: true },
              });
              const driverHtml = await driverResponse.text();
              driverForm.innerHTML = driverHtml;
              initializeDateTimeFields(driverForm, dataTimeFieldFormats);
              initializeAllDayCheckbox(driverForm);
              initializeChoices(driverForm);
              initializeFileUpload(driverForm);
              initializeToggles(driverForm);
              initializeNumberSpinner();
            }
          } else {
            const htmlForm = await response.text();
            form.innerHTML = htmlForm;
            initializeDateTimeFields(form, dataTimeFieldFormats);
            initializeAllDayCheckbox(form);
            initializeChoices(form);
            initializeFileUpload(form);
            initializeToggles(form);
            initializeNumberSpinner();
            if (form.action.includes("trailer")) {
              await initializeCheckTrailer();
            }
          }

          if (response.status === 200) {
            modifiedForms = modifiedForms.filter((_form) => _form !== form);
          } else if (!hasError) {
            hasError = true;
            errorForm = form;
          }

          if (truckChanged) {
            const truckForm = document.querySelector(
              "form[data-form-prefix='truck']",
            );
            if (truckForm) {
              const truckResponse = await fetch(truckForm.action, {
                headers: { ajax: true },
              });
              const truckHtml = await truckResponse.text();
              truckForm.innerHTML = truckHtml;
              initializeDateTimeFields(truckForm, dataTimeFieldFormats);
              initializeAllDayCheckbox(truckForm);
              initializeChoices(truckForm);
              initializeFileUpload(truckForm);
              initializeToggles(truckForm);
              initializeNumberSpinner();
              window.location.reload(true);
            }
          }
        } catch {
          hasError = true;
          errorForm = form;
        }
      }
      if (
        orderList &&
        Array.isArray(modifiedOrders) &&
        modifiedOrders.length &&
        JSON.stringify(modifiedOrders) !== JSON.stringify(previousOrders)
      ) {
        try {
          await bundle.axios.post(orderList.dataset.url, modifiedOrders, {
            headers: {
              "X-CSRFTOKEN": bundle.utils.getCookie("csrftoken"),
            },
          });
        } catch (error) {
          hasError = true;
        }
      }

      if (!hasError) {
        addAlert("success", gettext("Trip was updated successfully."));
        element.classList.remove("shown");
        setTimeout(function () {
          element.classList.add("hidden");
        }, 100);
      } else {
        addAlert("error", gettext("Issues occurred while saving changes."));
        if (errorForm) {
          const badge = errorForm.querySelector(".badge");
          if (badge) {
            badge.textContent = gettext("ERROR");
            badge.classList = "badge error";
          }
          errorForm.scrollIntoView();
        }
      }
    });

  window.addEventListener("beforeunload", function (e) {
    if (modifiedForms.length > 0) {
      e.preventDefault();
      e.returnValue = "";
    }
  });
}

export default {
  initializeMultiformSaveBanner,
};
